import { AbstractControl } from '@angular/forms';
import { format, parse } from 'date-fns';
import { es } from 'date-fns/locale';

export abstract class AbstractAdapter {
  protected _date(dateString: string | null): string {
    if (!dateString) {
      return '';
    }
    let date: Date;
    // Parse plain 'yyyy-MM-dd' as local date to avoid timezone-shift to previous day
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      date = parse(dateString, 'yyyy-MM-dd', new Date());
    } else {
      date = new Date(dateString);
    }
    return format(date, 'dd MMM yyyy', { locale: es });
  }

  protected _exists<T, Y>(value: T, data: Y, label: string = '-') {
    return value ? data : label;
  }

  protected transformCurrency = (amount: number): string => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  /**
   *
   * @param dateString
   * @param pattern
   * @returns
   * @example
   *  const fdate = (val: Date | null) =>
      this.cybertron.dateAndTime(val?.toString() ?? null, 'yyyy-MM-dd');
      fdate; // 2024-12-01

   */
  protected transformDateAndTime = (
    dateString: string | null,
    pattern: 'dd/MM/yyyy' | 'dd/MM/yy' | 'dd MMM yyyy HH:mm' | 'dd-MM-yy' | 'yyyy-MM-dd' | 'dd MMM yyyy' = 'dd/MM/yyyy'
  ): string => {
    if (!dateString) return '';
    let date: Date;
    // If the input is a plain date string like '2025-08-11', parse as local
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      date = parse(dateString, 'yyyy-MM-dd', new Date());
    } else {
      date = new Date(dateString);
    }
    return format(date, pattern, { locale: es }) + (pattern.includes('HH:mm') ? ' hs' : '');
  };
}

/**
 * Verifiy if a formcontrol have errors and was touched.
 *
 * @param control - FormControl instance.
 * @param errorName - form error name (default: 'required').
 * @returns `true` if the control contains errors. Otherwise will return `false`.
 */
export function hasControlError(control: AbstractControl | null | undefined, errorName: string = 'required'): boolean {
  return (control?.touched && control?.hasError(errorName)) ?? false;
}

export class CybertronAdapter extends AbstractAdapter {
  public dateAndTime = this.transformDateAndTime;
  public currency = this.transformCurrency;
}
